import { PluginFunc } from 'dayjs'

const APP_DATETIME_FORMAT = 'DD MMM YYYY HH:mm'
const APP_DATE_FORMAT = 'DD MMM YYYY'

const customFormat: PluginFunc = (_, dayjsClass) => {
  dayjsClass.prototype.defaultFormat = function (withTime = true) {
    if (withTime) {
      return this.tz().format(APP_DATETIME_FORMAT)
    } else {
      return this.format(APP_DATE_FORMAT)
    }
  }
}

export default customFormat
